module.exports = __webpack_public_path__ + "img/46.9d47b0b4.jpg";